export var CHECKED = 'checked';
export var NOTES = 'notes';
export var OPTIONS = 'options';
export var TEXT = 'text';
export var USERS = 'users';
export default {
  CHECKED: CHECKED,
  NOTES: NOTES,
  OPTIONS: OPTIONS,
  TEXT: TEXT,
  USERS: USERS
};